import { IOutcomeAutoCompleteItem } from '@patsnap/synapse_common_interface'
import { IAutoCompleteParams } from '../../types'
import { IHttp, IHttpWrap } from '../http/types'
import { BaseApi } from './baseApi'

export class OutcomeApi extends BaseApi {
  constructor(http: IHttp, baseUrl: string) {
    super(http, baseUrl)
  }

  async getAutocomplete(params: IAutoCompleteParams): Promise<IHttpWrap<IOutcomeAutoCompleteItem[]>> {
    const { keywords, limit = 5, cancelToken } = params
    return this.http({
      method: 'GET',
      url: this.getUrl('pharmsnap_webapi/1.0/outcome/autocomplete'),
      params: { prefix: keywords, limit },
      cache: true,
      cancelToken,
    })
  }
}
